<div class="page-engine-wrapper-popup-container" @mouseover="mouseOverTarget" @click="blockTargetClick">
    <div class="page-engine typography page-engin-margin-top"
         :class="{'isFullScreen': cPopupData.data.props.isFullScreen}"
         id="page-engine" :style="styles">
        <template v-for="obj in clonedVDom">
            <component
                    :is="obj.node.tag"
                    :fbNode="obj.node"
                    :key="obj.key"
                    v-bind="obj.node.data.props"
            ></component>
        </template>
    </div>
</div>
